import { Onboarding } from '../types'

const getFunnelFromLocalStorage = (): Onboarding => {
  const hintState = localStorage.getItem('hint-state')
  return hintState ? JSON.parse(hintState).state.funnel : 'palmistry-en'
}

export default getFunnelFromLocalStorage
